export default __webpack_public_path__ + "static/Zie_Pie-55be48508536f8006e6b2f0924ab9385.jpg";